export const EVENT_IMAGE_ZOOM_MIN = 0.7;
export const EVENT_IMAGE_ZOOM_MAX = 2.5;
export const EVENT_IMAGE_ZOOM_STEP = 0.1;
export const EVENT_IMAGE_ZOOM_DEFAULT = 1;

export const clampEventImageZoom = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return EVENT_IMAGE_ZOOM_DEFAULT;

  return Math.round(
    Math.min(EVENT_IMAGE_ZOOM_MAX, Math.max(EVENT_IMAGE_ZOOM_MIN, numericValue)) * 100
  ) / 100;
};

export const stepEventImageZoom = (value, direction) =>
  clampEventImageZoom(Number(value) + Math.sign(direction) * EVENT_IMAGE_ZOOM_STEP);
